function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import Auth from "../../functions/authenticate";
import { hasTenantFeature } from "../../functions/tenant-features";
import { EmailHeader } from "../email-automation/email-header";
import { orpPrettyMerge, NotEnabled, OrpMenu, OrpStatus, orpBucket, orpMailboxSummary, orpDayRange, orpDateIn, orpPlural, orpWindowPhrase, orpWaitText, ORP_WARM_DAYS, orpColdCap, orpEngagement } from "./common";
import { api, audienceApi, normalizeLists, qs, errText, isNotEnabled, num, idStr, parseMaybe, dateOnly } from "./api";

/*
 * Email → Outreach (2026-10-09 redesign, mockup Main.dc.html; same card family as the Journeys list).
 * One status card from GET infrastructure (warming / ready / paused mailboxes), status pills + search, then every
 * outreach campaign as a clickable card: name + status + ··· menu, the campaign as a sentence (leads from the
 * audience, then its emails and waits from GET programs/{id} steps), and a footer of sent / replied / interested
 * (GET programs, all time) with the mailboxes and the send window.
 *
 * Runway per program still comes from POST programs/{id}/estimate (read-only computation) for programs that are not
 * Draft / Completed / Canceled; it shows as a short phrase in the card footer.
 */

const RUNWAY_FOR = ["InReview", "Approved", "Running", "Paused"];
const PILLS = [["all", "All"], ["sending", "Sending"], ["ready", "Ready to start"], ["drafts", "Drafts"], ["finished", "Finished"]];
const MAX_CHIPS = 7;
class OutreachHomeComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "load", async () => {
      try {
        const [list, infra, replies] = await Promise.all([
        // no range: the card footers show all-time numbers
        api("GET", `/programs${qs({
          $top: 200
        })}`), api("GET", "/infrastructure").catch(e => {
          if (isNotEnabled(e)) throw e;
          return null;
        }), api("GET", `/replies${qs({
          unhandled: true,
          $top: 1
        })}`).catch(e => {
          if (isNotEnabled(e)) throw e;
          return null;
        })]);
        if (!this._alive) return;
        const rows = list && list.items || [];
        this.setState({
          rows,
          infra,
          replies,
          error: null
        });
        rows.filter(r => RUNWAY_FOR.indexOf((r.program || {}).status) > -1).slice(0, 20).forEach(r => {
          const id = r.program.id;
          api("POST", `/programs/${encodeURIComponent(id)}/estimate`, {}).then(e => this._alive && this.setState(s => ({
            runway: {
              ...s.runway,
              [id]: e
            }
          }))).catch(() => null);
        });
        // the steps for each card's sentence (GET programs/{id}; read-only)
        rows.slice(0, 40).forEach(r => {
          const id = (r.program || {}).id;
          if (!id) return;
          api("GET", `/programs/${encodeURIComponent(id)}`).then(d => this._alive && this.setState(s => ({
            details: {
              ...s.details,
              [id]: d
            }
          }))).catch(() => null);
        });
      } catch (e) {
        if (!this._alive) return;
        if (isNotEnabled(e)) this.setState({
          notEnabled: true
        });else this.setState({
          error: errText(e, "Outreach campaigns could not be loaded."),
          rows: this.state.rows || []
        });
      }
    });
    /** DELETE programs/{id} (Draft / Canceled): removes the program with its steps, leads and stats; a 409 'running' shows verbatim. */
    _defineProperty(this, "remove", async p => {
      this.setState({
        busy: p.id
      });
      try {
        await api("DELETE", `/programs/${encodeURIComponent(p.id)}`);
        if (!this._alive) return;
        this.setState({
          busy: null
        });
        this.load();
      } catch (e) {
        if (this._alive) this.setState({
          busy: null,
          error: errText(e, "The outreach campaign could not be deleted.")
        });
      }
    });
    _defineProperty(this, "detailPath", p => `/Email/campaigns/outreach/${encodeURIComponent(p.id)}?from=outreach`);
    _defineProperty(this, "open", p => () => this.props.history.push(this.detailPath(p)));
    this.state = {
      rows: null,
      infra: null,
      replies: null,
      runway: {},
      details: {},
      lists: null,
      filter: "all",
      q: "",
      error: null,
      notEnabled: false,
      busy: null
    };
    this._alive = true;
  }
  async componentDidMount() {
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    this.load();
    audienceApi("GET", "").then(d => this._alive && this.setState({
      lists: normalizeLists(d)
    })).catch(() => this._alive && this.setState({
      lists: []
    }));
  }
  componentWillUnmount() {
    this._alive = false;
  }
  menu(p) {
    const h = this.props.history;
    const items = [{
      label: "Open",
      run: this.open(p)
    }];
    if (p.status !== "Completed" && p.status !== "Canceled" && p.status !== "InReview") {
      items.push({
        label: p.status === "Running" ? "Settings and leads" : "Edit",
        run: () => h.push(`/Email/campaigns/outreach/${encodeURIComponent(p.id)}/edit`)
      });
    }
    items.push({
      label: "Replies",
      run: () => h.push(`/Email/outreach/replies?program=${encodeURIComponent(p.id)}`)
    });
    if (p.status === "Draft" || p.status === "Canceled") {
      items.push({
        label: "Delete",
        danger: true,
        confirm: "Delete this outreach campaign with its steps and leads?",
        confirmLabel: "Yes, delete",
        run: () => this.remove(p)
      });
    }
    return items;
  }

  // ---------------------------------------------------------------- status card

  statusCard() {
    const {
      infra
    } = this.state;
    if (!infra) return null;
    const domains = (infra.domains || []).filter(d => (d.domain || {}).status !== "retired");
    const m = orpMailboxSummary(infra.mailboxes);
    const on = `${orpPlural(m.total, "mailbox", "mailboxes")} on ${orpPlural(domains.length, "domain")}`;
    const manage = /*#__PURE__*/React.createElement(Link, {
      to: "/Email/senders/outreach"
    }, "Open Mailboxes");
    const icon = kind => /*#__PURE__*/React.createElement("span", {
      className: `orp-status-icon ${kind}`,
      "aria-hidden": "true"
    }, kind === "ok" ? /*#__PURE__*/React.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M5 12.5l4.5 4.5L19 7.5"
    })) : kind === "warn" ? /*#__PURE__*/React.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12 4l9 16H3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 10v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17.5v.01"
    })) : /*#__PURE__*/React.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v5l3 2"
    })));
    if (!m.total) {
      return /*#__PURE__*/React.createElement("div", {
        className: "orp-status-card"
      }, icon("wait"), /*#__PURE__*/React.createElement("div", {
        className: "orp-status-text"
      }, /*#__PURE__*/React.createElement("b", null, "No mailboxes yet"), /*#__PURE__*/React.createElement("span", null, "Outreach sends from mailboxes on your own sending domains. Add a domain and its mailboxes first; new mailboxes warm up for about three weeks before they reach full pace.")), /*#__PURE__*/React.createElement(Link, {
        className: "orp-btn",
        to: "/Email/senders/outreach"
      }, "Set up mailboxes"));
    }
    if (m.paused || m.problems.length) {
      const names = m.pausedList.map(x => x.address).filter(Boolean);
      const shown = names.slice(0, 3).join(", ") + (names.length > 3 ? ` and ${num(names.length - 3)} more` : "");
      return /*#__PURE__*/React.createElement("div", {
        className: "orp-status-card warn"
      }, icon("warn"), /*#__PURE__*/React.createElement("div", {
        className: "orp-status-text"
      }, /*#__PURE__*/React.createElement("b", null, m.paused ? `${orpPlural(m.paused, "mailbox is", "mailboxes are")} paused` : `${orpPlural(m.problems.length, "mailbox needs", "mailboxes need")} a look`), /*#__PURE__*/React.createElement("span", null, m.paused ? /*#__PURE__*/React.createElement(React.Fragment, null, shown ? `${shown}. ` : "", "Paused mailboxes send nothing until they are resumed, so campaigns using them slow down. ") : /*#__PURE__*/React.createElement(React.Fragment, null, "Bounces, failed sends or spam rescues are above the safe limit on ", m.problems.map(x => x.address).slice(0, 3).join(", "), ". "), on, " in all. ", manage)));
    }
    if (m.provisioning && !m.warming && !m.active) {
      return /*#__PURE__*/React.createElement("div", {
        className: "orp-status-card"
      }, icon("wait"), /*#__PURE__*/React.createElement("div", {
        className: "orp-status-text"
      }, /*#__PURE__*/React.createElement("b", null, "Your mailboxes are being set up"), /*#__PURE__*/React.createElement("span", null, on, ". Warm-up starts once they are connected. ", manage)));
    }
    if (m.warming) {
      const day = Math.max(0, m.minWarm);
      const pct = Math.max(3, Math.min(100, Math.round(day / ORP_WARM_DAYS * 100)));
      return /*#__PURE__*/React.createElement("div", {
        className: "orp-status-card"
      }, icon("wait"), /*#__PURE__*/React.createElement("div", {
        className: "orp-status-text"
      }, /*#__PURE__*/React.createElement("b", null, "Your mailboxes are warming up"), /*#__PURE__*/React.createElement("span", null, on, ", ", orpDayRange(m.minWarm, m.maxWarm), ". New mailboxes trade a few emails a day with other mailboxes while they build trust, so most of your sending can start around ", orpDateIn(m.daysToFirstSend), ".", m.provisioning ? ` ${orpPlural(m.provisioning, "mailbox has", "mailboxes have")} not started warming yet.` : "")), /*#__PURE__*/React.createElement("div", {
        className: "orp-progress"
      }, /*#__PURE__*/React.createElement("div", {
        className: "orp-bar"
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          width: `${pct}%`
        }
      })), /*#__PURE__*/React.createElement("span", null, "Day ", num(Math.min(day, ORP_WARM_DAYS)), " of ", ORP_WARM_DAYS, " \xB7 ", num(m.capNow), " of ", num(m.capFull), " emails a day")));
    }
    const ramping = m.minDay <= ORP_WARM_DAYS && m.capNow < m.capFull;
    return /*#__PURE__*/React.createElement("div", {
      className: "orp-status-card ok"
    }, icon("ok"), /*#__PURE__*/React.createElement("div", {
      className: "orp-status-text"
    }, /*#__PURE__*/React.createElement("b", null, "Your mailboxes are ready"), /*#__PURE__*/React.createElement("span", null, on, ". ", m.weekend ? `Outreach does not go out on weekends; on weekdays they can send up to ${num(orpCapWeekday(infra.mailboxes))} emails a day.` : `They can send up to ${num(m.capNow)} emails today${m.sentToday ? ` (${num(m.sentToday)} sent so far)` : ""}.`, ramping ? ` Still ramping up: full pace is about ${num(m.capFull)} a day, around ${orpDateIn(m.daysToFullPace)}.` : "")), ramping ? /*#__PURE__*/React.createElement("div", {
      className: "orp-progress"
    }, /*#__PURE__*/React.createElement("div", {
      className: "orp-bar ok"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: `${Math.max(3, Math.min(100, Math.round(m.minDay / ORP_WARM_DAYS * 100)))}%`
      }
    })), /*#__PURE__*/React.createElement("span", null, "Day ", num(Math.min(m.minDay, ORP_WARM_DAYS)), " of ", ORP_WARM_DAYS, " \xB7 ", num(m.capNow), " of ", num(m.capFull), " emails a day")) : null);
  }

  // ---------------------------------------------------------------- one campaign card

  chips(r) {
    const p = r.program || {};
    const leads = r.leads || {};
    const d = this.state.details[p.id];
    const aud = p.audienceId != null && this.state.lists ? this.state.lists.find(l => l.id === idStr(p.audienceId)) : null;
    const first = Number(leads.total) > 0 ? `${num(leads.total)} lead${Number(leads.total) === 1 ? "" : "s"}${aud ? ` from ${aud.name}` : ""}` : aud ? `No leads yet from ${aud.name}` : "No leads yet";
    const chips = [first];
    let emails = 0;
    (d && d.steps || []).forEach(st => {
      if (st.kind === "wait") chips.push(orpWaitText(st));else if (st.kind === "email") {
        emails += 1;
        chips.push(st.subject ? orpPrettyMerge(st.subject) : emails === 1 ? "First email" : "Follow-up");
      }
    });
    if (d && !emails) chips.push("No emails written yet");
    const more = Math.max(0, chips.length - MAX_CHIPS);
    return /*#__PURE__*/React.createElement("div", {
      className: "ejl-chips"
    }, chips.slice(0, MAX_CHIPS).map((c, i) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, i ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-arrow",
      "aria-hidden": "true"
    }, "\u2192") : null, /*#__PURE__*/React.createElement("span", {
      className: "ejl-chip"
    }, c))), more ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "ejl-arrow",
      "aria-hidden": "true"
    }, "\u2192"), /*#__PURE__*/React.createElement("span", {
      className: "ejl-chip more"
    }, more, " more step", more === 1 ? "" : "s")) : null, !d ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-chip more"
    }, "\u2026") : null);
  }
  runwayText(p) {
    const e = this.state.runway[p.id];
    if (!e) return null;
    if ((p.status === "Running" || p.status === "Paused") && e.projectedCompletion) return `last emails around ${dateOnly(e.projectedCompletion)}`;
    if (p.status === "Approved" && e.warmupDaysRemaining > 0) return `can start around ${orpDateIn(e.warmupDaysRemaining)}`;
    if (e.runwayDays) return `about ${num(Math.max(1, Math.ceil(e.runwayDays / 7)))} week${Math.ceil(e.runwayDays / 7) === 1 ? "" : "s"} once started`;
    return null;
  }
  card(r) {
    const p = r.program || {};
    const s = r.stats || {};
    const win = parseMaybe(p.windowJson);
    const busy = this.state.busy === p.id;
    const go = this.open(p);
    const runway = this.runwayText(p);
    const engaged = orpEngagement(parseMaybe(p.settingsJson), s); // "N opened · N clicked" when tracked
    return /*#__PURE__*/React.createElement("div", {
      key: p.id,
      className: `ejl-card orp-card${busy ? " busy" : ""}`,
      role: "link",
      tabIndex: 0,
      title: "Open campaign",
      onClick: go,
      onKeyDown: e => {
        if (e.key === "Enter" && e.target === e.currentTarget) go();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-card-top"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "ejl-name orp-name",
      to: this.detailPath(p),
      onClick: e => e.stopPropagation()
    }, p.name || "Untitled outreach"), /*#__PURE__*/React.createElement(OrpStatus, {
      program: p
    }), busy ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-busy"
    }, "Deleting\u2026") : /*#__PURE__*/React.createElement(OrpMenu, {
      items: this.menu(p)
    })), this.chips(r), /*#__PURE__*/React.createElement("div", {
      className: "ejl-foot"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, num(s.sent)), " sent"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, num(s.replies)), " replied"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, num(s.interested)), " interested"), engaged ? /*#__PURE__*/React.createElement("span", {
      className: "orp-dim"
    }, engaged) : null, runway ? /*#__PURE__*/React.createElement("span", {
      className: "orp-dim"
    }, runway) : null, /*#__PURE__*/React.createElement("span", {
      className: "ejl-grow"
    }), /*#__PURE__*/React.createElement("span", null, r.mailboxCount ? `From ${orpPlural(r.mailboxCount, "mailbox", "mailboxes")}` : "No mailboxes chosen", " \xB7 ", orpWindowPhrase(win))));
  }
  render() {
    if (!hasTenantFeature("outreach") || this.state.notEnabled) return /*#__PURE__*/React.createElement(NotEnabled, null);
    const {
      rows,
      replies,
      error,
      q,
      filter
    } = this.state;
    const loading = rows === null;
    const all = rows || [];
    const unhandled = replies && replies.counts ? Object.keys(replies.counts).filter(k => k !== "bounce").reduce((a, k) => a + (Number(replies.counts[k]) || 0), 0) : 0;
    const counts = {
      all: all.length,
      sending: 0,
      ready: 0,
      drafts: 0,
      finished: 0
    };
    all.forEach(r => {
      counts[orpBucket((r.program || {}).status)] += 1;
    });
    const ql = q.trim().toLowerCase();
    const order = {
      sending: 0,
      ready: 1,
      drafts: 2,
      finished: 3
    };
    const visible = all.filter(r => filter === "all" || orpBucket((r.program || {}).status) === filter).filter(r => !ql || String((r.program || {}).name || "").toLowerCase().includes(ql)).sort((a, b) => order[orpBucket(a.program.status)] - order[orpBucket(b.program.status)] || String(b.program.modifiedDate || "").localeCompare(String(a.program.modifiedDate || "")));
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view ec-view or-view orp-view"
    }, /*#__PURE__*/React.createElement(EmailHeader, {
      actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        className: "k-button k-button-md k-rounded-md k-button-outline k-button-outline-base",
        to: "/Email/outreach/replies"
      }, "Replies", unhandled ? ` · ${num(unhandled)}` : ""), /*#__PURE__*/React.createElement(Link, {
        className: "k-button k-button-md k-rounded-md k-button-outline k-button-outline-base",
        to: "/Email/senders/outreach"
      }, "Mailboxes"))
    }), error ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, error) : null, this.statusCard(), loading ? /*#__PURE__*/React.createElement("div", {
      className: "orp-empty"
    }, "Loading outreach campaigns\u2026") : !all.length ? /*#__PURE__*/React.createElement("div", {
      className: "orp-empty orp-start"
    }, /*#__PURE__*/React.createElement("b", null, "No outreach campaigns yet"), /*#__PURE__*/React.createElement("span", null, "Pick a list of business contacts, write a few short emails, choose the mailboxes they come from, and send for approval. Plunk sends them one at a time inside your sending hours."), /*#__PURE__*/React.createElement(Link, {
      className: "orp-btn primary",
      to: "/Email/campaigns/outreach/new"
    }, "Start an outreach campaign")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "ejl-bar orp-bar-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-pills",
      role: "tablist",
      "aria-label": "Show"
    }, PILLS.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      role: "tab",
      "aria-selected": filter === k,
      className: `ejl-pill${filter === k ? " on" : ""}`,
      onClick: () => this.setState({
        filter: k
      })
    }, l, " ", num(counts[k])))), /*#__PURE__*/React.createElement("span", {
      className: "ejl-grow"
    }), /*#__PURE__*/React.createElement("label", {
      className: "ejl-search"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "15",
      height: "15",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "11",
      cy: "11",
      r: "7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 20l-3.5-3.5"
    })), /*#__PURE__*/React.createElement("input", {
      value: q,
      onChange: e => this.setState({
        q: e.target.value
      }),
      placeholder: "Search outreach",
      "aria-label": "Search outreach"
    }))), visible.length ? /*#__PURE__*/React.createElement("div", {
      className: "orp-list"
    }, visible.map(r => this.card(r))) : /*#__PURE__*/React.createElement("div", {
      className: "orp-empty"
    }, ql ? "No outreach campaign matches your search." : "Nothing here right now.")), /*#__PURE__*/React.createElement("div", {
      className: "ejl-ready orp-explainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-ready-text"
    }, /*#__PURE__*/React.createElement("b", null, "How outreach is different"), /*#__PURE__*/React.createElement("span", null, "Plain emails sent one at a time from your own mailboxes, so they read like a personal note. Follow-ups stop the moment someone replies. Success is measured in replies, not opens.")), all.length ? /*#__PURE__*/React.createElement(Link, {
      className: "ejl-ready-btn",
      to: "/Email/campaigns/outreach/new"
    }, "New outreach campaign") : null));
  }
}

/** Weekday capacity across the sending mailboxes (for the weekend line): the ramp on the coming Monday. */
function orpCapWeekday(list) {
  const monday = new Date();
  monday.setDate(monday.getDate() + ((8 - monday.getDay()) % 7 || 7));
  return (list || []).filter(m => m.status === "active" || m.status === "warming").reduce((a, m) => a + orpColdCap(m.warmDay, m.dailyCap, monday), 0);
}
export default withRouter(OutreachHomeComponent);